// test2678
(2678 && 0);
